<div fxLayout="column">
  <mat-form-field>
    <input matInput placeholder="Rechercher une icône par son libellé" name="searchText" [(ngModel)]="searchText">
  </mat-form-field>

  <div class="p8-bdc_icon-picker__icons-container" fxLayout="row wrap">
    <button mat-icon-button *ngFor="let icon of icons; trackBy: trackByFn" (click)="addIcon(icon)">
      <mat-icon matTooltip="{{icon.label}}" >{{icon.label}}</mat-icon>
    </button>
  </div>

  <div>
    <app-pagination [page]="page" [maxItems]="MAX_ITEMS" [total]="total" [totalView]="totalView" (paginationChangedPage)="changePage($event)"></app-pagination>
  </div>
</div>

